import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-image-slider',
    label: 'acris-blog.elements.blogImageSlider.label',
    component: 'sw-cms-el-acris-blog-image-slider',
    configComponent: 'sw-cms-el-config-acris-blog-image-slider',
    previewComponent: 'sw-cms-el-preview-acris-blog-image-slider',
    defaultConfig: {
        addCoverImage: {
            source: 'static',
            value: 'default',
        },
        navigationArrows: {
            source: 'static',
            value: 'outside',
        },
        navigationDots: {
            source: 'static',
            value: 'none',
        },
        displayMode: {
            source: 'static',
            value: 'standard',
        },
        minHeight: {
            source: 'static',
            value: '300px',
        },
        verticalAlign: {
            source: 'static',
            value: null,
        },
        speed: {
            value: 300,
            source: 'static',
        },
        autoSlide: {
            value: false,
            source: 'static',
        },
        autoplayTimeout: {
            value: 5000,
            source: 'static',
        },
        isDecorative: {
            source: 'static',
            value: false,
        }
    }
});